import styled from 'styled-components';
import { HeaderReset } from '@carvana/showroom-theme';
import { HexToRgb } from '@utilities';
import Logo from '@Header/Logo';

export const HeaderWrapper = styled.div`
  ${HeaderReset}
  box-shadow: 1px 2px 3px 1px rgba(${props => HexToRgb(props.theme.carvana.blue.dark)}, 0.1);
  margin: 0 auto;
  max-width: ${props => props.theme.breakpoints.values.xl}px;
  position: relative;
  z-index: 10;

  * {
    box-sizing: border-box;
  }

  h6 {
    margin-top: 0;
    margin-bottom: 0.5rem;
  }
`;

export const HeaderMenuWrapper = styled.div`
  align-items: center;
  height: 72px;
  padding: 0 32px;
  display: none;
  background-color: ${props => props.theme.carvana.white.primary};

  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    display: flex;
  }
`;

export const HeaderMenuMobileWrapper = styled.div`
  position: relative;
  align-items: center;
  display: flex;
  height: 60px;
  padding: 0 15px 0 10px;
  background-color: ${props => props.theme.carvana.white.primary};

  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    display: none;
  }
`;

export const MobileLogo = styled(Logo)`
  && {
    max-height: 35px;
    max-width: 155px;
  }
`;
